import styled from "styled-components";
import { FlexWrapper, Text5, Text6 } from "../Common";

export const MainWrapper = styled.div`
  max-width: 100vw;
  background-color: black; 
  padding : 0px;
  margin : 0px ; 
`;

export const ImageLogo = styled.img`
  width: 200px;
  height: auto;
  object-fit: contain;
  @media screen and (max-width: 768px) {
    width : 100px ; 
    height: auto;
  }
`;

export const StyleTextOne = styled(Text5)`
  background: linear-gradient(
    90deg,
    #06d9ca 4.88%,
    #19b6f0 46.67%,
    #6e6cff 86.76%
  );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-align: left;
`;

export const FooterButton = styled.button`
  background-color: white;
  border: 0;
  border-radius: 4px;
  width: 100%;
  height: 50px;
  h5 {
    background: linear-gradient(
      90deg,
      #06d9ca 4.88%,
      #19b6f0 46.67%,
      #6e6cff 86.76%
    );

    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  margin: 20px 0px;
  @media screen and (max-width: 768px) {
    width : 80% ; 
    margin-bottom: 40px;
  }
`;

export const FooterLink = styled(Text6)`
  text-align: left;
  margin: 2px 0;
  color: white;
  cursor: pointer;
  font-weight : 600 ;  
  &:hover {
    background: linear-gradient(
      90deg,
      #06d9ca 4.88%,
      #19b6f0 46.67%,
      #6e6cff 86.76%
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;


export const FooterLinkHeading = styled(Text5)`
  text-align: left;
  margin: 8px 0;
  color: white;
  cursor: pointer;
  font-weight: 900;
`;

export const FooterSection = styled(FlexWrapper)`
  flex-wrap: wrap;
  min-width: ${(props) => props.minWidth || "300px"};
  @media screen and (max-width: 768px) {
    min-width: 90%;
  }
`;

export const FooterSectionTwo = styled(FlexWrapper)`
  @media screen and (max-width: 768px) {
    min-width: 100px;
    align-items: flex-start;
    width: 50%;
  }
`;

export const FooterMainContainer = styled(FlexWrapper)`
  row-gap: 40px;
  @media screen and (max-width: 768px) {
    flex-direction: row;

  }
`;

export const FooterRowContainer = styled(FlexWrapper)`
  @media screen and (max-width: 768px) {
    flex-direction: row;
    align-items: flex-start;
    row-gap: 40px;
  }
`;

export const SocialMediaIconContainer = styled(FlexWrapper)`
  gap: ${props=>props.gap || '30px'};
  @media screen and (max-width: 768px) {
    justify-content: center;
    flex-direction: row;
  }
`;

export const SocialMediaIcon = styled.img`
  width: 40px;
  height: 40px;
  object-fit: cover;
`;

export const SpecialContainerMobile = styled.div`
  display: flex;
  width: 100vw;
  gap: 20px;
  display: none;
  div {
    min-width : 100px;
    h5{
      font-size : 0.7rem ;
      width : 100%;
      word-break :break-all; 
    }
  }
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 768px) {
    display: flex;
  }
`;
export const SpecialContainerDesktop = styled(FlexWrapper)`
  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const SpecialSocialMediaContainer = styled(SocialMediaIconContainer)`
  @media screen and (max-width: 768px) {
    display: none;
  }
`;
